import { ENDPOINTS } from "utils/endpoints";
import { DELETE_API_CALL, GET_API_CALL, PUT_API_CALL } from "utils/services";
import { store } from "store";
import {
  GET_CONGREGATIONS_REDUCER,
  REQUESTED_CONGREGATIONS_REDUCER,
} from "store/actionTypes";
import SHOW_TOAST from "utils/showToast";
import { TypeOptions } from "react-toastify";
import { createQueryParams } from "utils/constants";

export type PaginationTypes = {
  page: number;
  limit: number;
};
export type Options = PaginationTypes & {};
export type NewCongregationType = {
  name: string;
  state: string;
  zipcode: string;
  city: string;
};
export const getCongregations = (data: any) => (dispatch: Function) => {
  dispatch({
    type: GET_CONGREGATIONS_REDUCER,
    payload: {
      isLoading: true,
    },
  });
  GET_API_CALL(ENDPOINTS.CONGREGATIONS.GET, "", (data: any) => {
    if (data.isSuccess || data.data.status === "success") {
      const result = data.data.result;
      const count = data.data.pagination.totalRecords;
      dispatch({
        type: GET_CONGREGATIONS_REDUCER,
        payload: {
          page: {
            page: data.page,
            limit: data.limit,
          },
          result: result.map((item: any) => {
            return {
              ...item,
              state: item.state.name,
              stateId: item.state.id,
              city: item.city.name,
              cityId: item.city.id,
            };
          }),
          count,
          isLoading: false,
        },
      });
    } else {
      dispatch({
        type: GET_CONGREGATIONS_REDUCER,
        payload: {
          isLoading: false,
        },
      });
    }
  });
};

export const getRequestedCongregations =
  (data: any) => (dispatch: Function) => {
    dispatch({
      type: REQUESTED_CONGREGATIONS_REDUCER,
      payload: {
        isLoading: true,
      },
    });
    GET_API_CALL(
      ENDPOINTS.CONGREGATIONS.GET_REQUESTED_CONGREGATION,
      "",
      (data: any) => {
        if (data.isSuccess || data.data.status === "success") {
          console.log("getRequestedCongregations", data);
          const result = data.data.result;
          const count = data.data.pagination.totalRecords;
          dispatch({
            type: REQUESTED_CONGREGATIONS_REDUCER,
            payload: {
              page: {
                page: data.page,
                limit: data.limit,
              },
              result: result.map((item: any) => {
                return {
                  ...item,
                  name: item.congregationName,
                  state: item.state.name,
                  stateId: item.state.id,
                  city: item.city.name,
                  cityId: item.city.id,
                };
              }),
              count,
              isLoading: false,
            },
          });
        }
        dispatch({
          type: REQUESTED_CONGREGATIONS_REDUCER,
          payload: {
            isLoading: false,
          },
        });
      }
    );
  };

export const getAllStates = (data: any) => (dispatch: Function) => {
  GET_API_CALL(ENDPOINTS.CONGREGATIONS.GETSTATE, "", (data: any) => {
    if (data.isSuccess || data.data.status === "success") {
      const result = data.data.result;
      const count = data.data.pagination.totalRecords;
      dispatch({
        type: GET_CONGREGATIONS_REDUCER,
        payload: {
          allStates: {
            page: {
              page: data.page,
              limit: data.limit,
            },
            result,
            count,
            isLoading: false,
          },
        },
      });
    }
  });
};

export const getAllCongregationByCity = (data: any) => (dispatch: Function) => {
  GET_API_CALL(
    ENDPOINTS.CONGREGATIONS.GET_CONGRIGATION,
    "?" + createQueryParams(data.data),
    (data: any) => {
      if (data.isSuccess || data.data.status === "success") {
        const result = data.data.result;
        const count = data.data.pagination.totalRecords;
        dispatch({
          type: GET_CONGREGATIONS_REDUCER,
          payload: {
            allCongregationBy: {
              page: {
                page: data.page,
                limit: data.limit,
              },
              result,
              count,
              isLoading: false,
            },
          },
        });
      }
    }
  );
};

export const getAllCities = (data: any) => (dispatch: Function) => {
  GET_API_CALL(
    ENDPOINTS.CONGREGATIONS.GETCITIES,
    "?" + createQueryParams(data.data),
    (data: any) => {
      if (data.isSuccess || data.data.status === "success") {
        const result = data.data.result;
        const count = data.data.pagination.totalRecords;
        dispatch({
          type: GET_CONGREGATIONS_REDUCER,
          payload: {
            allCities: {
              page: {
                page: data.page,
                limit: data.limit,
              },
              result,
              count,
              isLoading: false,
            },
          },
        });
      }
    }
  );
};

export const updateCongregation = (params: any) => (dispatch: Function) => {
  PUT_API_CALL(ENDPOINTS.CONGREGATIONS.UPDATE, params.data, (data: any) => {
    if (data.isSuccess || data.data.status === "success") {
      const { message } = data.data;
      SHOW_TOAST(message, "success");
      dispatch(getCongregations({}));
      params.callback(data);
    } else {
      dispatch({
        type: GET_CONGREGATIONS_REDUCER,
        payload: {
          isLoading: false,
        },
      });
      params.callback();
    }
  });
};

export const congregationRequestStatus =
  (params: any) => (dispatch: Function) => {
    PUT_API_CALL(
      ENDPOINTS.CONGREGATIONS.REQUEST_STATUS,
      params.data,
      (data: any) => {
        if (data.isSuccess || data.data.status === "success") {
          const { message } = data.data;
          SHOW_TOAST(message, "success");
          dispatch(getCongregations({}));
          params.callback(data);
        } else {
          dispatch({
            type: GET_CONGREGATIONS_REDUCER,
            payload: {
              isLoading: false,
            },
          });
          params.callback();
        }
      }
    );
  };

export const deleteCongregation = (params: any) => (dispatch: Function) => {
  if (store.getState().CongregationReducer.congregations.isLoading) {
    return;
  }
  dispatch({
    type: GET_CONGREGATIONS_REDUCER,
    payload: {
      isLoading: true,
    },
  });
  DELETE_API_CALL(
    ENDPOINTS.CONGREGATIONS.DELETE + "/" + params.data.id,
    (data: any) => {
      if (data.isSuccess) {
        const { message } = data.data;
        SHOW_TOAST(message, "success");
        dispatch(getCongregations({}));
      } else {
        dispatch({
          type: GET_CONGREGATIONS_REDUCER,
          payload: {
            isLoading: false,
          },
        });
      }
    }
  );
};
